










































import Vue from "vue";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "ErrorCard",
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      copyClicked: false,
    };
  },
  methods: {
    ...mapActions(["setShowErrorDialog"]),
    copyToClipboard() {
      this.copyClicked = true;
      navigator.clipboard.writeText(JSON.stringify(this.error, null, 2));

      setTimeout(() => {
        this.copyClicked = false;
      }, 3000);
    },
  },
});
